import { render } from "./StandardV2Header.vue?vue&type=template&id=6d496fd1&scoped=true"
import script from "./StandardV2Header.vue?vue&type=script&lang=js"
export * from "./StandardV2Header.vue?vue&type=script&lang=js"

import "./StandardV2Header.vue?vue&type=style&index=0&id=6d496fd1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d496fd1"]])

export default __exports__